export default class ToneSelector extends React.PureComponent
  constructor: (props) ->
    super(props)

    @tonesRef = React.createRef()

    @handleKeyDown = @handleKeyDown.bind(this)

  updateTone: (tone, e) ->
    if tone != @props.tone      
      @props.onChange(tone)

      # We decided to focus on source only when mouse click (not for keyboard or touch, to leave focus on tab)
      if e.nativeEvent?.pointerType == 'mouse'
        @props.focusSource()

  handleKeyDown: (e) ->
    if e.code in ['ArrowLeft', 'ArrowRight']
      e.preventDefault()

      if e.code == 'ArrowLeft'
        @focusPrevButton(e.target)
      else
        @focusNextButton(e.target)

  focusPrevButton: (element) ->
    @focusSiblingButton(element, -1)

  focusNextButton: (element) ->
    @focusSiblingButton(element, 1)

  focusSiblingButton: (element, offset) ->
    if @tonesRef.current
      buttons = @tonesRef.current.querySelectorAll('button')
      index   = Array.from(buttons).indexOf(element)
      sibling = buttons[index + offset]

      sibling.focus() if sibling

  render: ->
    if !@props.hidden
      <div className="tones d-none d-lg-flex"
           ref={@tonesRef}>
        { @renderButtons() }
      </div>
    else
      ''

  renderButtons: ->
    @props.tones.map((tone) =>
      className = "btn btn-link tone tone-#{tone}"
      className += ' selected' if @props.tone == tone

      label = @props.i18n.labels[tone]

      <button key={tone}
              className={className}
              onKeyDown={@handleKeyDown}
              onClick={@updateTone.bind(this, tone)}>
        {label}
      </button>
    )
